/**
 * @lumen/web entry point (frontend-architecture §1 / §6).
 * In mock mode (`VITE_MOCK=1`) the MSW worker is started before the first render so every request is intercepted.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { queryClient } from './lib/api/queryClient';
import { Toaster } from './components/Toaster';
import { ErrorBoundary } from './components/ErrorBoundary';
import { installTheme } from './stores/ui';
import './styles/globals.css';

async function boot() {
  installTheme();
  // the literal env check is replaced at build time, so a production build drops the MSW chunk entirely (§5)
  if (import.meta.env.VITE_MOCK === '1') {
    const { startMocks } = await import('./mocks/browser');
    await startMocks();
  }
  createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <App />
          <Toaster />
        </QueryClientProvider>
      </ErrorBoundary>
    </StrictMode>,
  );
}
void boot();
